import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import "./SocialLinkModal.css";

function SocialLinkModal({
  show,
  handleClose,
  mode,
  socialLink,
}) {
  const [link, setLink] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (show) {
      if (mode === "edit") {
        setLink(socialLink?.link || "");
      } else {
        setLink("");
      }

      setError("");
    }
  }, [show, mode, socialLink]);

  const handleSave = () => {
    if (!link.trim()) {
      setError("This field is required");
      return;
    }

    console.log({
      link,
    });

    handleClose();
  };

  const handleDelete = () => {
    console.log("Delete Link");
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="common-modal social-link-modal"
    >
      {/* Header */}

      <Modal.Header className="social-link-modal__header">
        <Modal.Title className="social-link-modal__title">
          <Button
            variant="link"
            className="we-back-btn p-0 me-2"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>

          {mode === "edit"
            ? "Edit Social Link"
            : "Add Social Link"}
        </Modal.Title>

        <button
          type="button"
          className="btn-close"
          onClick={handleClose}
        ></button>
      </Modal.Header>

      {/* Body */}

      <Modal.Body className="social-link-modal__body">
        <Form.Group>
          <Form.Label className="social-link-modal__label">
            Title <span className="text-danger">*</span>
          </Form.Label>

          <Form.Control
            type="text"
            value={link}
            placeholder="Enter Social Link"
            className={`social-link-modal__input ${
              error ? "social-link-modal__input--error" : ""
            }`}
            onChange={(e) => {
              setLink(e.target.value);
              setError("");
            }}
          />

          {error && (
            <div className="social-link-modal__error">
              {error}
            </div>
          )}
        </Form.Group>
      </Modal.Body>

      {/* Footer */}

      <Modal.Footer className="social-link-modal__footer">
        {mode === "edit" ? (
          <Button
            variant="link"
            className="social-link-modal__delete"
            onClick={handleDelete}
          >
            Delete Link
          </Button>
        ) : (
          <div></div>
        )}

        <Button
          className="social-link-modal__save"
          onClick={handleSave}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SocialLinkModal;